<template>
<div>
   <div class="detailsTitle">
       <h4>转货单详情</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <el-form :inline="true" ref="sChange" enctype="multipart/form-data" :model="sChange"   class="demo-form-inline inpBox" label-width="120px" size="mini">
         <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>转货信息</span>
            </h4>
            <div>
            <el-form-item label="新货主名称:" prop="newCustomerName">
              <span>{{sChange.newCustomerName}}</span>
            </el-form-item>
             <el-form-item label="备注信息:" prop="remark">
              <span>{{sChange.remark}}</span>
            </el-form-item>
            </div>
          </div>
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
            </h4>
            <div>
              <el-table :data="sVirtualGoods"    bordersize="mini"  class="table"  style="width: 100%" center border >
                  <el-table-column type="index" width="55" label="序号"></el-table-column>
                  <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
                  <el-table-column property="organizationName" width="240" label="所在仓库"></el-table-column>
                  <el-table-column property="steelMillName" width="200" label="产地"></el-table-column>
                  <el-table-column property="specification" width="140"  label="规格"></el-table-column>
                  <el-table-column property="model" width="150" label="材质"></el-table-column>
                  <!-- <el-table-column property="root" width="120" label="单件支数"></el-table-column>
                  <el-table-column property="length" width="120" label="长度(m)"></el-table-column> -->
                  <el-table-column prop="plan"  min-width="180"  label="转货量(吨/件)">
                    <template scope="scope">
                      <div>
                        {{scope.row.planWeight}} / {{scope.row.planNum}}
                      </div>
                    </template>
                  </el-table-column>
              </el-table>
              <div class="searchBtnBox">
                <p style="font-size: 14px; margin-left:20px">合计吨数:<span class="red">{{sChange.planWeight}}</span>吨&nbsp; &nbsp; 合计件数：<span class="red">{{sChange.planNum}}</span>件</p>
              </div>
            </div>
          </div>
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>转货记录</span>
            </h4>
            <div>
                <div>
                    <el-form-item label="创建时间:" prop="createTime">
                      <el-date-picker v-model="sChange.createTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                        type="datetime"
                        :readonly="true"
                          placeholder=""
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="创建人:" prop="createUserName">
                      <span>{{sChange.createUserName}}</span>
                    </el-form-item>
                </div>
                <div v-if="sChange.completeTime">
                    <el-form-item label="完成时间:" prop="completeTime">
                      <el-date-picker v-model="sChange.completeTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                        type="datetime"
                        :readonly="true"
                          placeholder=""
                      ></el-date-picker>
                    </el-form-item>
                </div>
            </div>
          </div>
         <div class="addressBox" v-if="spjd.length>0" style="margin-top:20px;">
            <h4 class="title" style="margin-bottom:10px;">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审批记录</span>
            </h4>
            <div>
               <el-table :data="spjd"    bordersize="mini"  class="table"  style="width: 100%" center border >
                  <el-table-column type="index" width="55" label="序号"></el-table-column>
                  <el-table-column property="checkUserName" width="160" label="审批人"></el-table-column>
                  <el-table-column property="checkTime" :formatter="dateTimeFormat" width="200" label="审批时间"></el-table-column>
                  <el-table-column property="status"  width="130" label="审批状态" >
                    <template scope="scope">
                      {{[ "待审批","通过", "驳回" ][scope.row.status]}}
                    </template>
                  </el-table-column>
                  <el-table-column property="checkReason" min-width="260" label="审批意见"></el-table-column>
              </el-table>
            </div>
          </div>
    </el-form>
</div>
</template>

<script>
import { dateTimeFormat } from '@/utils/util'
import { SVCdetail } from '@/api/soc-stock-cosco'
export default {
  data () {
    let id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      id: id,
      sChange: {},
      sVirtualGoods: [],
      spjd: []
    }
  },
  created () {
    SVCdetail({ id: this.id }).then(res => {
      this.sVirtualGoods = res.virtualChangeExt.sVirtualGoods
      this.sChange = res.virtualChangeExt
      this.spjd = res.flowAuditLogs

    })
  },
  mounted () {
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.addressBox{
  margin-bottom: 20px;
}
.inpBox  /deep/.el-input__inner{
  border:none;
  padding: 0;
  color:#333;
   font-size: 14px;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form-item--mini.el-form-item{
    margin-bottom: 0px;
}
/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
 /deep/.el-input__suffix, /deep/.el-input__icon{
   display: none;
 }
 /deep/.el-step__description{
  margin-top: 10px;
}
</style>
